<app-dialog></app-dialog>
<router-outlet></router-outlet>